module.exports = __webpack_public_path__ + "img/general.562c747a.png";